//export const GAME_WIDTH = 800;
//export const GAME_HEIGHT = 600;

export const gameConfig = {
  humanCount: 5,
};

export const entityData = {
  penguin: {
    image: 'penguin',
    speed: 150,
    health: [3, 4, 5],
    bulletSpeed: 400,
    shootFrequency: [2, 2.5, 3],
    ultimateDuration: 2000,
    ultimateType: 'superscatter',
    bulletImage: 'heroBullet',
    manaMax: 100,
    scatterCount: [5, 7, 9],
    bulletDamage: [1, 1.5, 2]
  },
  crocodile: {
    image: 'crocodile',
    speed: 150,
    health: [3, 4, 5],
    bulletSpeed: 600,
    shootFrequency: [1, 1.5, 2],
    ultimateDuration: 2000,
    ultimateType: 'stim',
    bulletImage: 'powerBullet',
    manaMax: 100,
    bulletDamage: [2, 3, 4]
  },
  goat: {
    image: 'goat',
    speed: 120,
    health: [4, 5, 6],
    bulletSpeed: 500,
    shootFrequency: [1.5, 2, 2.5],
    ultimateDuration: 3000,
    ultimateType: 'invincibility',
    bulletImage: 'shieldBullet',
    manaMax: 100,
    bulletDamage: [1.5, 2, 2.5]
  },
  fastEnemy: {
    image: 'fastEnemy',
    speed: 200,
    health: 1
  },
  tankEnemy: {
    image: 'tankEnemy',
    speed: 30,
    health: 5
  },
  shooterEnemy: {
    image: 'shooterEnemy',
    speed: 40,
    health: 2,
    bulletSpeed: 300,
    bulletImage: 'enemyBullet',
    shootInterval: 4000
  },
  human: {
    image: 'human'
  }
};

export const waves = [
  { fastEnemy: 5, killCount: 20 },
  { fastEnemy: 7, tankEnemy: 1, killCount: 80 },
  { fastEnemy: 12, tankEnemy: 2, shooterEnemy: 3, killCount: 200 }
];

export const heroCosts = {
  penguin: 2,
  crocodile: 1
};

export const maxTeamSize = 5;
